import { css, SerializedStyles } from '@emotion/react';

import { Theme } from '@shipengine/giger-theme';

export const getLanguageSelectorListStyles = (theme: Theme): SerializedStyles =>
    css({
        width: theme.spacing(22),
        margin: `${theme.spacing()}px auto`,
    });

export const getLanguageSelectorSpinnerStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        minHeight: theme.spacing(25),
    });
